"use client";
import { useTranslation } from "@/i18n/client";
import { Lang } from "@/i18n/settings";
import { useEffect } from "react";
import { useCookies } from "react-cookie";
import { toast } from "sonner";
import { Button } from "../ui/button";

const cookieName = "cookie-consent";
export default function CookieConsent({ lang }: { lang: Lang }) {
  const { t } = useTranslation(lang, "common");
  const [cookies, setCookie] = useCookies([cookieName]);

  const cookieConsent = () => {
    const message = t("cookies.text");
    const acceptBtn = t("cookies.proceed");
    const cancelBtn = t("cookies.cancel");

    const id = toast.message(
      <div className="flex flex-col gap-4 rounded-md font-cairo">
        <p className="text-secondary">{message}</p>
        <div className="flex items-center gap-4 capitalize">
          <Button
            onClick={() => {
              setCookie(cookieName, new Date().getTime(), {
                path: "/",
                expires: new Date(new Date().setFullYear(new Date().getFullYear() + 1)),
              });
              toast.dismiss(id);
            }}
            className="border-secondary/70 bg-gold-medium capitalize text-black transition-all duration-150 ease-in hover:bg-secondary/80"
          >
            {acceptBtn}
          </Button>
          <Button
            onClick={() => {
              toast.dismiss(id);
            }}
            variant={"outline"}
            className="border-secondary/70 capitalize text-secondary/80 transition-all duration-150 ease-in hover:bg-secondary/10"
          >
            {cancelBtn}
          </Button>
        </div>
      </div>,

      {
        className: "rounded-md border border-white/20 ",
        duration: Infinity,
      }
    );
  };

  useEffect(() => {
    if (!cookies[cookieName]) {
      cookieConsent();

      return;
    }
  }, [lang]);

  return <></>;
}
